console.warn('@aegisjsproject/core/events.js is deprecated. Please use @aegisjsproject/callback-registry instead.');

export * from '@aegisjsproject/callback-registry/events.js';
